import React from "react";

const EstimateList = React.lazy(() => import("./EstimateList"));
const EstimateShow = React.lazy(() => import("./EstimateShow"));
const EstimateCreate = React.lazy(() => import("./EstimateCreate"));
const EstimateEdit = React.lazy(() => import("./EstimateEdit"));

export default {
  list: EstimateList,
  show: EstimateShow,
  create: EstimateCreate,
  edit: EstimateEdit,
};
